import { computed } from 'vue'
import { useRoute } from 'vue-router'

declare module 'vue-router' {
  interface RouteMeta {
    /**
     * A modal creation flow — the channel wizard —, where the whole screen is the task: on a phone
     * the bottom bar is hidden, and the flow's own cross is the way out
     * (docs/plans/mobile-navigation.md, MN9).
     */
    creationFlow?: boolean
  }
}

/** Whether the current route is a modal creation flow, which the bottom bar gives way to. */
export function useCreationFlow() {
  const route = useRoute()
  return computed(() => route.matched.some((record) => record.meta.creationFlow === true))
}
